import type { Resource } from '../../';
export const country_countries_MA: Resource = {"default":"Morocco"};
